module.exports = __webpack_public_path__ + "files/bf1afc9c751aa5d12e7725989405eb5c.svg";